module.exports = __webpack_public_path__ + "img/Apoptosis-BRCA_SpatialResearch.0270892e.png";